import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';
import './styles.css';
import strings from '../../../../../globalization';
import { withRouter } from 'react-router-dom';
import { AgGridReact } from 'ag-grid-react';
import Select from 'react-select';
import moment from 'moment';
import PermitsHeader from '../../../../../components/PermitsHeader';

import 'react-daterange-picker/dist/css/react-calendar.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import dimensions from '../../../../../util/dimensions-util';
import { adminImages, agencyImages } from '../../../../../assets/images';
import DateRangePicker from 'react-daterange-picker';
import TextInput from '../../../../../components/TextInput';
import Button from '../../../../../components/Button';
import SannaLogo from '../../../../../components/SannaLogo';

const { vw: widthConstant, vh: heightConstant } = dimensions;

const Desktop = props => {
  const {
    onClick,
    onChange,
    selectedStatus,
    agencyList,
    selectedAgency,
    selectedAgencyOrderList,
    searchText,
    dates,
    roleId,
  } = props;

  const tabs = [
    {
      label: 'Users',
      id: 1,
      route: 'usage-management',
    },
  ];

  // Status options for dropdown
  const statusOptions = [
    { label: 'All', value: 'all' },
    { label: 'Failed', value: 'PAYMENT_FAILED' },
    { label: 'Completed', value: 'PAYMENT_COMPLETED' },
    { label: 'Pending', value: 'PAYMENT_PENDING' },
  ];

  console.log('selectedAgencyOrderList:', selectedAgencyOrderList);
  // Convert agencyList to react-select format
  const agencyOptions = agencyList?.map(agency => ({
    value: agency.id,
    label: agency.name || agency.companyName,
    data: agency
  })) || [];


  const columnDefs = [
    {
      headerName: 'Order Id',
      field: 'orderId',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      resizable: true,
      autoHeight: true,
      sortable: false,
      wrapText: true,
      cellStyle: { lineHeight: 1.5 },
      cellRendererFramework: ({ data: { orderId } }) => {
        return <div className={styles.sessionTime}>{orderId}</div>;
      },
    },
    {
      headerName: 'Payment Id',
      field: 'paymentId',
      headerClass: styles.rowHeader,
      width: 210 * widthConstant,
      resizable: true,
      sortable: false,
      autoHeight: true,
      cellRendererFramework: ({ data: { paymentId } }) => {
        return <div className={styles.sessionTime}>{paymentId}</div>;
      },
    },

    {
      headerName: 'Reference Id',
      field: 'referenceId',
      headerClass: styles.rowHeader,
      width: 150 * widthConstant,
      resizable: true,

      autoHeight: true,
      wrapText: true,
      cellRendererFramework: ({ data: { referenceId } }) => {
        return <div className={styles.sessionTime}>{referenceId}</div>;
      },
    },
    {
      headerName: 'Razorpay Payment Status',
      field: 'razorpayStatus',
      headerClass: styles.rowHeader,
      width: 250 * widthConstant,
      flex: 1,
      resizable: true,
      sortable: false,
      cellRendererFramework: ({ data: { razorpayStatus } }) => {
        return (
          <div className={styles.sessionTime}>
            {razorpayStatus}
          </div>
        );
      },
    },
     {
      headerName: 'Transaction Date',
      field: 'createdDate',
      headerClass: styles.rowHeader,
      width: 120 * widthConstant,
      resizable: true,
      sortable: false,
      flex: 1,
      cellRendererFramework: ({ data: { createdDate } }) => {
        return (
          <div className={styles.sessionTime}>
            {moment(createdDate).format('MMM Do YYYY HH:mm')}
          </div>
        );
      },
    },
    {
      headerName: 'Amount',
      field: 'amount',
      headerClass: styles.rowHeader,
      width: 120 * widthConstant,
      resizable: true,
      sortable: false,
      flex: 1,
      cellRendererFramework: ({ data: { amount } }) => {
        return (
          <div className={styles.sessionTime}>
            {amount}
          </div>
        );
      },
    },
    {
      headerName: 'Status',
      field: 'status',
      headerClass: styles.rowHeader,
      width: 120 * widthConstant,
      resizable: true,
      sortable: false,
      flex: 1,
      cellRendererFramework: ({ data: { status } }) => {
        return (
          <div className={styles.sessionTime}>
            {status}
          </div>
        );
      },
    },
  ];

  const [showDate, setShowDate] = useState(false);
  const [gridApi, setGridApi] = useState(null);

  useEffect(() => {
    console.log(gridApi);
    if (gridApi) {
      // gridApi.setRowHeight(50);
    }
    if (gridApi && selectedAgencyOrderList.length > 10) {
      console.log('changing to normal');
      gridApi.setDomLayout('normal');
    } else if (gridApi) {
      console.log('changing to autoHeight');
      gridApi.setDomLayout('autoHeight');
    }
  }, [gridApi, selectedAgencyOrderList]);

  const onGridReady = params => {
    setGridApi(params.api);
  };

  const onCellClick = (event, index) => {
    onClick('rowClick', event.data);
  };

  const onSelect = dates => {
    onChange('date', {
      startDate: moment(dates.start).format('YYYY-MM-DD'),
      endDate: moment(dates.end).format('YYYY-MM-DD'),
      dates,
    });
    toggleDate();
  };

  const toggleDate = () => {
    setShowDate(!showDate);
  };

  const onTabClick = id => {
    switch (id) {
      case 1:
        // onClick('statusRoute', { route: 'users-list', id: id });
        break;
      default:
        break;
    }
  };

  const formatDate = date => moment(date).format('MMM Do YY');
  const rowStyle = { border: 'none', cursor: 'pointer' };
  const getRowStyle = params => {
    if (params.node.rowIndex % 2 === 0) {
      return { background: '#f6f6f6', border: 'none' };
    }
  };

  const handleClear = () => {
    setShowDate(false);
    onClick('clearFilters');
  };

  const handleAgencyChange = selectedOption => {
    onChange('onSelectAgency', selectedOption?.data);
  };

  const handleStatusChange = selectedOption => {
    onChange('onStatusChange', selectedOption?.value);
  };

  const selectedAgencyValue = selectedAgency ? {
    value: selectedAgency.id,
    label: selectedAgency.name || selectedAgency.companyName,
    data: selectedAgency
  } : null;

  const selectedStatusValue = statusOptions.find(opt => opt.value === selectedStatus) || statusOptions[0];

  return (
    <div>
      <PermitsHeader
        title="Refund management"
        onTabClick={onTabClick}

      />
      <div className={styles.bodyContainer}>
        <div className={styles.header}>
          <div className={styles.left}>
            {/* Agency Dropdown */}
            <div className={styles.dropdownWrapper}>
              <Select
                options={agencyOptions}
                value={selectedAgencyValue}
                onChange={handleAgencyChange}
                placeholder="Select Agency"
                isClearable
                className={styles.selectDropdown}
              />
            </div>

            {/* Status Dropdown */}
            <div className={styles.dropdownWrapper}>
              <Select
                options={statusOptions}
                value={selectedStatusValue}
                onChange={handleStatusChange}
                placeholder="Select Status"
                className={styles.selectDropdown}
              />
            </div>

            {/* Date Range Picker */}
            <div className={styles.dateWrapper}>
              <Button
                onClick={toggleDate}
                buttonStyle="secondary"
                label={dates ? `${formatDate(dates.start)} - ${formatDate(dates.end)}` : 'Select Date Range'}
                className={styles.dateBtn}
              />
              {showDate ? (
                <div className={styles.datePicker}>
                  <DateRangePicker
                    numberOfCalendars={1}
                    selectionType="range"
                    onSelect={onSelect}
                    className={styles.dateRange}
                    value={dates}
                    singleDateRange={true}
                  />
                </div>
              ) : null}
            </div>


          </div>

          <div className={styles.right}>
            {/* Clear Filters Button */}
            <Button
              onClick={handleClear}
              buttonStyle="secondary"
              label="Clear Filters"
              className={styles.clearBtn}
            />
            <Button
              onClick={() => onClick('onFetchAgencyOrders')}
              buttonStyle="primary"
              label="Fetch Orders"
              className={styles.applyBtn}
              disabled={!selectedAgency}
            />
          </div>
        </div>

        <div
          className={[
            'ag-theme-balham',
            styles.tableWrapper,
            selectedAgencyOrderList?.length > 10
              ? styles.tableWrapperNormal
              : styles.tableWrapperAutoHeight,
          ].join(' ')}>
          <AgGridReact
            onGridReady={onGridReady}
            rowStyle={rowStyle}
            getRowStyle={getRowStyle}
            rowHoverHighlight={true}
            columnDefs={columnDefs}
            rowHeight={50 * heightConstant}
            headerHeight={50 * heightConstant}
            defaultColDef={{ sortable: true }}
            rowClass={[styles.gridRowClass]}
            pagination={true}
            paginationPageSize={100}
            onCellClicked={(event, index) => onCellClick(event, index)}
            rowData={selectedAgencyOrderList}
            domLayout="normal"
          />
        </div>
        <div className={styles.bottomLabel}>
          Showing {selectedAgencyOrderList.length}
        </div>
      </div>
      <div className={styles.SannaLogo}>
        <SannaLogo />
      </div>
    </div>
  );
};

export default Desktop;